import AltruonCheckoutComCardForm from "../checkout/AltruonCheckoutComCardForm";
import BasisTheoryCardForm from "./BasisTheoryCardForm";

/** Embedded (Altruon.js iframe) variant: same parent messaging as the Checkout.com card form. */
const AltruonBasisTheoryCardForm = (props) => (
  <AltruonCheckoutComCardForm {...props} cardForm={BasisTheoryCardForm} />
);

export default AltruonBasisTheoryCardForm;
